import React from 'react';
export function Footer() {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    window.history.pushState({}, '', href);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  };
  return <footer className="border-t border-white/10 py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-263">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-264">
        {/* Brand Column */}
        <div className="space-y-4" data-id="element-265">
          <a href="/" onClick={e => handleLinkClick(e, '/')} className="text-2xl font-bold tracking-tight block" style={{
          fontFamily: "'Space Grotesk', sans-serif"
        }} data-id="element-266">
            <span className="text-white" data-id="element-267">ai</span>
            <span className="text-[#c9a84c]" data-id="element-268">.</span>
            <span className="text-white" data-id="element-269">web</span>
          </a>
          <p className="text-white/40 text-sm leading-relaxed" data-id="element-270">
            Affordable, professional website design for Dublin businesses.
            Launch your online presence today with our €249 package.
          </p>
          <p className="text-white/40 text-sm pt-4" data-id="element-271">
            © 2026 ai.web — Affordable Website Design Ireland
          </p>
          <p className="text-white/30 text-xs" data-id="element-272">
            aiwebsitepackage.com — All rights reserved.
          </p>
        </div>

        {/* Services Column */}
        <div data-id="element-273">
          <h3 className="text-white font-bold mb-6" data-id="element-274">Services</h3>
          <ul className="space-y-3 text-sm text-white/60" data-id="element-275">
            <li data-id="element-276">
              <a href="/services/electrician-website-dublin" onClick={e => handleLinkClick(e, '/services/electrician-website-dublin')} className="hover:text-[#c9a84c] transition-colors" data-id="element-277">
                Electrician Websites
              </a>
            </li>
            <li data-id="element-278">
              <a href="/services/restaurant-website-dublin" onClick={e => handleLinkClick(e, '/services/restaurant-website-dublin')} className="hover:text-[#c9a84c] transition-colors" data-id="element-279">
                Restaurant Websites
              </a>
            </li>
            <li data-id="element-280">
              <a href="/services/barber-website-dublin" onClick={e => handleLinkClick(e, '/services/barber-website-dublin')} className="hover:text-[#c9a84c] transition-colors" data-id="element-281">
                Barber Websites
              </a>
            </li>
            <li data-id="element-282">
              <a href="/services/trades-website-dublin" onClick={e => handleLinkClick(e, '/services/trades-website-dublin')} className="hover:text-[#c9a84c] transition-colors" data-id="element-283">
                Trades Websites
              </a>
            </li>
            <li data-id="element-284">
              <a href="/services/hotel-website-ireland" onClick={e => handleLinkClick(e, '/services/hotel-website-ireland')} className="hover:text-[#c9a84c] transition-colors" data-id="element-285">
                Hotel Websites
              </a>
            </li>
          </ul>
        </div>

        {/* Resources Column */}
        <div data-id="element-286">
          <h3 className="text-white font-bold mb-6" data-id="element-287">Resources</h3>
          <ul className="space-y-3 text-sm text-white/60" data-id="element-288">
            <li data-id="element-289">
              <a href="/blog" onClick={e => handleLinkClick(e, '/blog')} className="hover:text-[#c9a84c] transition-colors" data-id="element-290">
                Blog
              </a>
            </li>
            <li data-id="element-291">
              <a href="/blog/website-cost-ireland-2026" onClick={e => handleLinkClick(e, '/blog/website-cost-ireland-2026')} className="hover:text-[#c9a84c] transition-colors" data-id="element-292">
                Website Costs 2026
              </a>
            </li>
            <li data-id="element-293">
              <a href="/blog/website-design-dublin-small-businesses" onClick={e => handleLinkClick(e, '/blog/website-design-dublin-small-businesses')} className="hover:text-[#c9a84c] transition-colors" data-id="element-294">
                Small Business Guide
              </a>
            </li>
            <li data-id="element-295">
              <a href="/blog/seo-small-businesses-ireland" onClick={e => handleLinkClick(e, '/blog/seo-small-businesses-ireland')} className="hover:text-[#c9a84c] transition-colors" data-id="element-296">
                SEO for Beginners
              </a>
            </li>
          </ul>
        </div>

        {/* Company Column */}
        <div data-id="element-297">
          <h3 className="text-white font-bold mb-6" data-id="element-298">Company</h3>
          <ul className="space-y-3 text-sm text-white/60" data-id="element-299">
            <li data-id="element-300">
              <a href="/" onClick={e => handleLinkClick(e, '/')} className="hover:text-[#c9a84c] transition-colors" data-id="element-301">
                Home
              </a>
            </li>
            <li data-id="element-302">
              <a href="/pricing" onClick={e => handleLinkClick(e, '/pricing')} className="hover:text-[#c9a84c] transition-colors" data-id="element-303">
                Pricing
              </a>
            </li>
            <li data-id="element-304">
              <a href="/contact" onClick={e => handleLinkClick(e, '/contact')} className="hover:text-[#c9a84c] transition-colors" data-id="element-305">
                Contact
              </a>
            </li>
            <li data-id="element-306">
              <a href="/privacy" onClick={e => handleLinkClick(e, '/privacy')} className="hover:text-[#c9a84c] transition-colors" data-id="element-307">
                Privacy Policy
              </a>
            </li>
            <li data-id="element-308">
              <a href="/terms" onClick={e => handleLinkClick(e, '/terms')} className="hover:text-[#c9a84c] transition-colors" data-id="element-309">
                Terms of Service
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/10 text-center" data-id="element-310">
        <p className="text-white/40 text-sm flex items-center justify-center gap-1" data-id="element-311">
          Made with <span className="text-red-500" data-id="element-312">♥</span> for Dublin
          businesses
        </p>
      </div>
    </footer>;
}